export const inArray = (state) => Object.values(state.list);
export const byId = (state) => (id) => state.list[id];
